import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as MobilePushMessageService from 'services/messaging/mobile/message';

export const useMobilePushMessageService = () => {
  const { token } = useSelector((store) => store.user_data);

  const createMessage = async (options = {}) => {
    const { error, payload } = await MobilePushMessageService.create({
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to create message at this time. Please try again.');
      return { message: null };
    }

    toast.success('Message created successfully.');
    return { message: payload };
  };

  const fetchMessages = async (options = {}) => {
    const { error, payload } = await MobilePushMessageService.read({ ...options, token });
    if (error) {
      return {
        messages: [],
        size: 0
      };
    }

    const {
      data: messages,
      meta: { size }
    } = payload;
    return { messages, size };
  };

  const searchMessages = async (keys, keyword, options = {}) => {
    const { error, payload } = await MobilePushMessageService.search(keys, keyword, {
      ...options,
      token
    });
    if (error) {
      return { messages: [], size: 0 };
    }

    const {
      data: messages,
      meta: { size }
    } = payload;
    return { messages, size };
  };

  const updateMessage = async (id, options = {}) => {
    const { error, payload } = await MobilePushMessageService.updateById(id, { ...options, token });
    if (error) {
      toast.error(error);
      return { message: null };
    }

    toast.success('Message updated successfully.');
    return { message: payload };
  };

  return { fetchMessages, createMessage, searchMessages, updateMessage };
};
